import React, { useCallback } from "react";
import ModalWrapper from "..";
import useAuthStore from "../../../store/Auth";
import { Button } from "../../button";
import toast from "react-hot-toast";
import { useDeleteDetailCode } from "../../../hooks/user/mutation";
import { useTranslation } from "react-i18next";

interface DeleteDetailCodeModalProps {
  codeDetails: {
    masterCode: number;
    detailCode: number;
    isDeletable: number;
  };
  isOpen: boolean;
  onOpenChange: () => void;
}

const DeleteDetailCodeModal = ({
  codeDetails,
  isOpen,
  onOpenChange,
}: DeleteDetailCodeModalProps) => {
  const user = useAuthStore((state) => state.user);

  const {
    mutateAsync: DeleteDetailCode,
    isPending: isDeleteDetailCodeLoading,
  } = useDeleteDetailCode();
  const { t } = useTranslation();

  const handleDeleteCode = useCallback(async () => {
    if (codeDetails.isDeletable === 1) {
      toast.error(t("codeCannotBeDeleted"));
      onOpenChange();
      return;
    }

    try {
      const body = {
        detailCode: codeDetails.detailCode.toString(),
        masterCode: codeDetails.masterCode.toString(),
        createdBy: user?.user_id,
        locationId: user?.n_LocationID,
      };
      await DeleteDetailCode(body);
      toast.success(t("codeDeleted"));
    } catch (error) {
      toast.error(t("somethingWentWrong"));
    } finally {
      onOpenChange();
    }
  }, [
    t,
    DeleteDetailCode,
    codeDetails.detailCode,
    codeDetails.isDeletable,
    codeDetails.masterCode,
    onOpenChange,
    user?.n_LocationID,
    user?.user_id,
  ]);

  return (
    <ModalWrapper isOpen={isOpen} onOpenChange={onOpenChange}>
      <div className="flex flex-col gap-8 justify-center items-center">
        <p className="text-lg md:text-2xl font-medium">
          {t("confirmDeleteCode")}
        </p>

        <div className="flex gap-1 items-center">
          <Button
            onClick={handleDeleteCode}
            isLoading={isDeleteDetailCodeLoading}
            className=" bg-red-600 hover:bg-red-700"
          >
            {t("delete")}
          </Button>

          <Button onClick={onOpenChange}>{t("close")}</Button>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default React.memo(DeleteDetailCodeModal);
